

export const z = [
    [0, 0, 1],
    [-2.05, -1.75, 1.015],
    [-4.1, -3.55, 1.03],
    [-6.2, -5.3, 1.044],
    [-8.25, -7.1, 1.059],
    [-10.35, -8.85, 1.074],
    [-12.4, -10.65, 1.089],
    [-14.5, -12.4, 1.104],
    [-16.55, -14.2, 1.119],
    [-18.65, -15.95, 1.133],
    [-14.9, -12.75, 1.107],
    [-11.15, -9.55, 1.08],
    [-7.45, -6.35, 1.053],
    [-3.7, -3.15, 1.027],
    [0, 0, 1],
    [-1.85, -1.55, 1.013],
    [-3.7, -3.15, 1.027],
    [-5.55, -4.75, 1.04],
    [-7.45, -6.35, 1.053],
    [-9.3, -7.95, 1.067],
    [-11.15, -9.55, 1.08],
    [-13.05, -11.15, 1.093],
    [-14.9, -12.75, 1.107],
    [-16.75, -14.35, 1.12],
    [-18.65, -15.95, 1.133], 
    [-14.9, -12.75, 1.107], 
    [-11.15, -9.55, 1.08], 
    [-7.45, -6.35, 1.053], 
    [-3.7, -3.15, 1.027], 
    [0, 0, 1],
];

// ↓ 大图内的元素位置表
export const p = {
    // 数据含义： x, y, width, height
    i4: [0, 0, 280, 240],
    line: [845.4, 55, 920, 49], // 短线
    line2: [845.3, 11.4, 1091, 38.1], // 长线
    i5: [0, 242, 280, 240],
    i6: [0, 484, 280, 240],
    i3: [0, 726, 280, 240],
    i7: [0, 970, 280, 240],
    i0: [0, 1211, 280, 240],
    i1: [0, 1451, 280, 240],
    i2: [0, 1691, 280, 240],
    i4Up: [280, 0, 280, 240],
    i5Up: [280, 242, 280, 240],
    i6Up: [280, 484, 280, 240],
    i3Up: [280, 726, 280, 240],
    i7Up: [280, 970, 280, 240],
    i0Up: [280, 1211, 280, 240],
    i1Up: [280, 1451, 280, 240],
    i2Up: [280, 1691, 280, 240],
    i4Bluer: [562.1, 0, 280, 240],
    i5Bluer: [562.1, 242, 280, 240],
    i6Bluer: [562.1, 484, 280, 240],
    i3Bluer: [562.1, 726, 280, 240],
    i7Bluer: [562.1, 970, 280, 240],
    i0Bluer: [562.1, 1211, 280, 240],
    i1Bluer: [562.1, 1451, 280, 240],
    i2Bluer: [562.1, 1691, 280, 240],
    i8: [842.1, 1808, 280, 240],
    i8Up: [1122.2, 1808, 280, 240],
    i8Bluer: [1404.5, 1808, 280, 240],
    bonus: [1760.5, 1938, 285, 108],
    bonus2: [1804.8, 1706.5, 241, 228],
    bonusBluer: [1760.5, 1575.1, 285, 108],
    bonus2Bluer: [1804.8, 1327.8, 241, 228],
    iFire: [843.8, 1110.3, 500, 500],
    light: [843.9, 108, 364, 802],
    star: [1450, 1327.8, 131, 97],
    star2: [1628.9, 1238.7, 118, 112],
    n8: [1619, 1660, 120, 128],
    n7: [1613, 1522, 120, 128],
    n6: [1927.8, 311.6, 120, 128],
    n5: [1808.1, 311.6, 120, 128],
    n4: [1688.3, 311.6, 120, 128],
    n3: [1568.3, 311.6, 120, 128],
    n2: [1448.3, 311.6, 120, 128],
    n1: [1328.3, 311.6, 120, 128],
    n0: [1208.3, 311.6, 120, 128],
    n9: [1613, 1376.1, 120, 128],
    n6Bluer: [1928, 443.5, 120, 128],
    n5Bluer: [1808, 443.5, 120, 128],
    n4Bluer: [1688.3, 443.5, 120, 128],
    n3Bluer: [1568.3, 443.5, 120, 128],
    n2Bluer: [1448.3, 443.5, 120, 128],
    n1Bluer: [1328.3, 443.5, 120, 128],
    n0Bluer: [1208.3, 443.5, 120, 128],
    n8Bluer: [1461, 576, 120, 128],
    n7Bluer: [1337, 576, 120, 128],
    n9Bluer: [1211, 576, 120, 128],
    nw0: [1821, 582.8, 120, 128],
    nw1: [1701, 575.6, 120, 128],
    nw2: [1581, 575.6, 120, 128],
    nw9: [1928, 711.4, 120, 128],
    nw8: [1808, 711.4, 120, 128],
    nw7: [1688, 706.4, 120, 128],
    nw6: [1568, 706.4, 120, 128],
    nw5: [1448, 714.4, 120, 128],
    nw4: [1327.6, 714.4, 120, 128],
    nw3: [1207.6, 714.4, 120, 128],
    bonusPharaon: [1464, 1434, 107, 135],
    gBg: [1213, 107, 827, 199],
    blueLight: [1788, 1068, 260, 242],
    coin: [1871.5, 840, 174, 54],
    slims: [0, 2030, 785, 18],
    slimsMid: [6, 1938, 96, 79],
    fireBall: [1930, 906, 114, 116],
    lava: [849.5, 1612.5, 668, 190], // 中奖后显示的横幅背景图，黄色的 
};

export const Q = [
    [185.45, 106.65, .414],
    [163.5, 100.5, .479],
    [141.6, 94.35, .544],
    [119.65, 88.2, .609],
    [97.75, 82.1, .674],
    [75.8, 75.95, .74],
    [53.85, 69.8, .805],
    [31.9, 63.7, .87],
    [9.95, 57.55, .935],
    [-11.95, 51.35, 1],
    [-6.8, 52.85, .985],
    [-1.6, 54.25, .969],
    [3.45, 55.7, .954],
    [8.6, 57.15, .939],
    [13.7, 58.6, .924],
    [11.3, 57.95, .931],
    [8.85, 57.25, .938],
    [6.4, 56.5, .945],
    [3.95, 55.85, .953],
    [1.5, 55.15, .96],
    [-.9, 54.45, .967],
    [-3.3, 53.8, .974],
    [-5.75, 53.1, .982],
    [-8.2, 52.4, .989],
    [-10.65, 51.75, .996],
    [28.75, 62.8, .879],
    [68.2, 73.8, .762],
    [107.7, 84.85, .645],
    [147.15, 95.9, .528],
    [186.6, 106.95, .411],
];


export const E = [{
    x_position: 0,
    y_position: 128.9,
    scale_factor: 1
}, {
    x_position: -1.45,
    y_position: 128.35,
    scale_factor: 1.01
}, {
    x_position: -2.9,
    y_position: 127.8,
    scale_factor: 1.02
}, {
    x_position: -4.35,
    y_position: 127.25,
    scale_factor: 1.031
}, {
    x_position: -5.8,
    y_position: 126.7,
    scale_factor: 1.041
}, {
    x_position: -7.25,
    y_position: 126.15,
    scale_factor: 1.051
}, {
    x_position: -8.7,
    y_position: 125.6,
    scale_factor: 1.061
}, {
    x_position: -10.15,
    y_position: 125.05,
    scale_factor: 1.071
}, {
    x_position: -11.6,
    y_position: 124.5,
    scale_factor: 1.081
}, {
    x_position: -8.75,
    y_position: 125.6,
    scale_factor: 1.061
}, {
    x_position: -5.9,
    y_position: 126.7,
    scale_factor: 1.042
}, {
    x_position: -3.05,
    y_position: 127.75,
    scale_factor: 1.022
}, {
    x_position: -.2,
    y_position: 128.85,
    scale_factor: 1.002
}, {
    x_position: 2.65,
    y_position: 129.9,
    scale_factor: .982
}, {
    x_position: 5.5,
    y_position: 131,
    scale_factor: .962
}, {
    x_position: 8.35,
    y_position: 132.05,
    scale_factor: .942
}, {
    x_position: 5.85,
    y_position: 131.1,
    scale_factor: .959
}, {
    x_position: 3.35,
    y_position: 130.15,
    scale_factor: .977
}, {
    x_position: .85,
    y_position: 129.2,
    scale_factor: .994
}, {
    x_position: -1.6,
    y_position: 128.25,
    scale_factor: 1.012
}, {
    x_position: -4.1,
    y_position: 127.3,
    scale_factor: 1.029
}, {
    x_position: -6.6,
    y_position: 126.35,
    scale_factor: 1.047
}, {
    x_position: -9.1,
    y_position: 125.4,
    scale_factor: 1.064
}, {
    x_position: -11.6,
    y_position: 124.5,
    scale_factor: 1.081
}, {
    x_position: -9.65,
    y_position: 125.25,
    scale_factor: 1.068
}, {
    x_position: -7.7,
    y_position: 126,
    scale_factor: 1.054
}, {
    x_position: -5.8,
    y_position: 126.7,
    scale_factor: 1.041
}, {
    x_position: -3.85,
    y_position: 127.4,
    scale_factor: 1.027
}, {
    x_position: -1.9,
    y_position: 128.15,
    scale_factor: 1.014
}, {
    x_position: 0,
    y_position: 128.9,
    scale_factor: 1
}];

export const R = [{
    x_position: 88.5,
    y_position: 96.2,
    scale_factor: 0
}, {
    x_position: 78.45,
    y_position: 90.45,
    scale_factor: .273
}, {
    x_position: 68.3,
    y_position: 84.7,
    scale_factor: .326
}, {
    x_position: 58.2,
    y_position: 78.95,
    scale_factor: .38
}, {
    x_position: 48.1,
    y_position: 73.15,
    scale_factor: .433
}, {
    x_position: 38,
    y_position: 67.4,
    scale_factor: .486
}, {
    x_position: 27.9,
    y_position: 61.7,
    scale_factor: .54
}, {
    x_position: 17.8,
    y_position: 55.95,
    scale_factor: .593
}, {
    x_position: 7.7,
    y_position: 50.15,
    scale_factor: .646
}, {
    x_position: -2.35,
    y_position: 44.4,
    scale_factor: .7
}, {
    x_position: -12.45,
    y_position: 38.65,
    scale_factor: .753
}, {
    x_position: -22.55,
    y_position: 32.9,
    scale_factor: .807
}, {
    x_position: -32.65,
    y_position: 27.1,
    scale_factor: .86
}, {
    x_position: -42.85,
    y_position: 21.35,
    scale_factor: .913
}, {
    x_position: -43.25,
    y_position: 20.95,
    scale_factor: .917
}, {
    x_position: -43.7,
    y_position: 20.65,
    scale_factor: .921
}, {
    x_position: -44.2,
    y_position: 20.2,
    scale_factor: .925
}, {
    x_position: -44.65,
    y_position: 19.85,
    scale_factor: .928
}, {
    x_position: -45.15,
    y_position: 19.45,
    scale_factor: .932
}, {
    x_position: -45.6,
    y_position: 19.1,
    scale_factor: .936
}, {
    x_position: -46.1,
    y_position: 18.65,
    scale_factor: .94
}, {
    x_position: -46.5,
    y_position: 18.35,
    scale_factor: .944
}, {
    x_position: -47.05,
    y_position: 17.9,
    scale_factor: .947
}, {
    x_position: -47.5,
    y_position: 17.55,
    scale_factor: .951
}, {
    x_position: -48,
    y_position: 17.1,
    scale_factor: .955
}, {
    x_position: -48.45,
    y_position: 16.8,
    scale_factor: .959
}, {
    x_position: -48.85,
    y_position: 16.35,
    scale_factor: .963
}, {
    x_position: -49.4,
    y_position: 16,
    scale_factor: .966
}, {
    x_position: -49.85,
    y_position: 15.6,
    scale_factor: .97
}, {
    x_position: 111.75,
    y_position: 108.65,
    scale_factor: 0
}];



export const P = [{
    x_position: 168.4,
    y_position: 192.85,
    scale_factor: 0
}, {
    x_position: 171.5,
    y_position: 186.5,
    scale_factor: .314
}, {
    x_position: 174.6,
    y_position: 180.15,
    scale_factor: .355
}, {
    x_position: 177.75,
    y_position: 173.7,
    scale_factor: .397
}, {
    x_position: 180.85,
    y_position: 167.4,
    scale_factor: .438
}, {
    x_position: 183.95,
    y_position: 160.95,
    scale_factor: .479
}, {
    x_position: 187.1,
    y_position: 154.6,
    scale_factor: .52
}, {
    x_position: 190.15,
    y_position: 148.25,
    scale_factor: .562
}, {
    x_position: 193.3,
    y_position: 141.85,
    scale_factor: .603
}, {
    x_position: 196.45,
    y_position: 135.45,
    scale_factor: .644
}, {
    x_position: 199.5,
    y_position: 129.1,
    scale_factor: .686
}, {
    x_position: 202.65,
    y_position: 122.7,
    scale_factor: .727
}, {
    x_position: 205.8,
    y_position: 116.3,
    scale_factor: .768
}, {
    x_position: 208.9,
    y_position: 109.95,
    scale_factor: .809
}, {
    x_position: 208.55,
    y_position: 109.6,
    scale_factor: .815
}, {
    x_position: 208.2,
    y_position: 109.25,
    scale_factor: .822
}, {
    x_position: 207.8,
    y_position: 108.95,
    scale_factor: .828
}, {
    x_position: 207.45,
    y_position: 108.55,
    scale_factor: .834
}, {
    x_position: 207.1,
    y_position: 108.2,
    scale_factor: .84
}, {
    x_position: 206.75,
    y_position: 107.9,
    scale_factor: .846
}, {
    x_position: 206.4,
    y_position: 107.55,
    scale_factor: .852
}, {
    x_position: 206.1,
    y_position: 107.2,
    scale_factor: .858
}, {
    x_position: 205.7,
    y_position: 106.9,
    scale_factor: .864
}, {
    x_position: 205.35,
    y_position: 106.55,
    scale_factor: .87
}, {
    x_position: 205,
    y_position: 106.2,
    scale_factor: .876
}, {
    x_position: 204.65,
    y_position: 105.9,
    scale_factor: .882
}, {
    x_position: 204.3,
    y_position: 105.55,
    scale_factor: .888
}, {
    x_position: 203.95,
    y_position: 105.2,
    scale_factor: .894
}, {
    x_position: 203.55,
    y_position: 104.85,
    scale_factor: .901
}, {
    x_position: 169.6,
    y_position: 193.25,
    scale_factor: 0
}];


export const X = [
    -58, -58, -58, -58.05, -58.1, -58.15, -58.25, -58.3, -58.45,
    -58.55, -58.7, -58.85, -59, -59.15, -59.35, -59.55, -59.75,
    -59.95, -60.2, -60.4, -60.65, -60.95, -61.2, -61.45, -61.75,
    -62.05, -62.35, -62.65, -62.95, -63.25, -63.55, -63.9, -64.2,
    -64.5, -64.85, -65.15, -65.5, -65.8, -66.1, -66.4, -66.7, -67,
    -67.3, -67.55, -67.8, -68.05, -68.3, -68.55, -68.75, -68.95,
    -69.1, -69.25, -69.4, -69.5, -69.6, -69.65, -69.7, -69.75, -69.75,
    -69.75, -69.75, -69.7, -69.65, -69.6, -69.5, -69.45, -69.3, -69.2,
    -69.05, -68.9, -68.75, -68.6, -68.4, -68.2, -68, -67.8, -67.55,
    -67.35, -67.1, -66.8, -66.55, -66.3, -66, -65.7, -65.4, -65.1, -64.8,
    -64.5, -64.2, -63.85, -63.55, -63.25, -62.9, -62.6, -62.25, -61.95,
    -61.65, -61.35, -61.05, -60.75, -60.45, -60.2, -59.95, -59.7,
    -59.45, -59.2, -59, -58.8, -58.65, -58.5, -58.35,
    -58.25, -58.15, -58.1, -58.05, -58
];

export const A = [
    .5, .488, .48, .48, .469, .461, .461, .449, .441, .441, .43,
    .422, .422, .41, .398, .398, .391, .379, .379, .371, .359, .359,
    .352, .34, .34, .328, .32, .32, .309, .301, .301, .289, .281, .281,
    .27, .262, .262, .25, .25, .25, .262, .27, .27, .281, .289, .289,
    .301, .309, .309, .32, .328, .34, .34, .352, .359, .359, .371, .379,
    .379, .391, .398, .398, .41, .422, .43, .43, .441, .449, .449, .461,
    .469, .469, .48, .488, .5
];


export const O = [{
    x_p: -59.95,
    y_p: -64.5,
    a: 1,
    sc: 1
}, {
    x_p: -57.05,
    y_p: -61.4,
    a: .922,
    sc: .952
}, {
    x_p: -54.15,
    y_p: -58.35,
    a: .84,
    sc: .904
}, {
    x_p: -51.3,
    y_p: -55.25,
    a: .762,
    sc: .856
}, {
    x_p: -48.4,
    y_p: -52.2,
    a: .68,
    sc: .808
}, {
    x_p: -45.5,
    y_p: -49.1,
    a: .609,
    sc: .76
}, {
    x_p: -42.65,
    y_p: -46.05,
    a: .531,
    sc: .712
}, {
    x_p: -39.75,
    y_p: -42.95,
    a: .449,
    sc: .664
}, {
    x_p: -36.9,
    y_p: -39.9,
    a: .371,
    sc: .616
}, {
    x_p: -34,
    y_p: -36.8,
    a: .301,
    sc: .568
}, {
    x_p: -36.6,
    y_p: -39.6,
    a: .371,
    sc: .611
}, {
    x_p: -39.2,
    y_p: -42.35,
    a: .441,
    sc: .654
}, {
    x_p: -41.8,
    y_p: -45.1,
    a: .512,
    sc: .698
}, {
    x_p: -44.35,
    y_p: -47.9,
    a: .578,
    sc: .741
}, {
    x_p: -46.95,
    y_p: -50.65,
    a: .648,
    sc: .784
}, {
    x_p: -49.55,
    y_p: -53.4,
    a: .719,
    sc: .827
}, {
    x_p: -52.15,
    y_p: -56.2,
    a: .789,
    sc: .87
}, {
    x_p: -54.75,
    y_p: -58.95,
    a: .859,
    sc: .914
}, {
    x_p: -57.35,
    y_p: -61.7,
    a: .93,
    sc: .957
}, {
    x_p: -59.95,
    y_p: -64.5,
    a: 1,
    sc: 1
}];


export const H = [{
    x_position: 366.15,
    y_position: 19.55,
    scale_factor: .204
}, {
    x_position: 325.5,
    y_position: 17.4,
    scale_factor: .292
}, {
    x_position: 284.8,
    y_position: 15.25,
    scale_factor: .381
}, {
    x_position: 244.15,
    y_position: 13.15,
    scale_factor: .469
}, {
    x_position: 203.45,
    y_position: 10.95,
    scale_factor: .558
}, {
    x_position: 162.8,
    y_position: 8.85,
    scale_factor: .646
}, {
    x_position: 122.15,
    y_position: 6.7,
    scale_factor: .735
}, {
    x_position: 81.5,
    y_position: 4.55,
    scale_factor: .823
}, {
    x_position: 40.8,
    y_position: 2.4,
    scale_factor: .912
}, {
    x_position: .1,
    y_position: .2,
    scale_factor: 1
}, {
    x_position: 1.5,
    y_position: .35,
    scale_factor: .997
}, {
    x_position: 2.85,
    y_position: .4,
    scale_factor: .994
}, {
    x_position: 4.25,
    y_position: .45,
    scale_factor: .991
}, {
    x_position: 5.6,
    y_position: .55,
    scale_factor: .988
}, {
    x_position: 7,
    y_position: .6,
    scale_factor: .985
}, {
    x_position: 6.3,
    y_position: .6,
    scale_factor: .987
}, {
    x_position: 5.6,
    y_position: .55,
    scale_factor: .988
}, {
    x_position: 4.95,
    y_position: .55,
    scale_factor: .99
}, {
    x_position: 4.25,
    y_position: .45,
    scale_factor: .991
}, {
    x_position: 3.55,
    y_position: .4,
    scale_factor: .993
}, {
    x_position: 2.85,
    y_position: .4,
    scale_factor: .994
}, {
    x_position: 2.2,
    y_position: .35,
    scale_factor: .995
}, {
    x_position: 1.5,
    y_position: .35,
    scale_factor: .997
}, {
    x_position: .8,
    y_position: .3,
    scale_factor: .998
}, {
    x_position: .1,
    y_position: .2,
    scale_factor: 1
}, {
    x_position: 73.3,
    y_position: 4.1,
    scale_factor: .841
}, {
    x_position: 146.5,
    y_position: 7.95,
    scale_factor: .682
}, {
    x_position: 219.75,
    y_position: 11.85,
    scale_factor: .522
}, {
    x_position: 292.95,
    y_position: 15.7,
    scale_factor: .363
}, {
    x_position: 366.15,
    y_position: 19.55,
    scale_factor: .204
}];


